import axios from 'axios'

/** 后端根地址，可用 .env 中 VUE_APP_API_BASE 覆盖 */
const baseURL =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.VUE_APP_API_BASE) ||
    'https://request.vip49vip.top'


const http = axios.create({
  baseURL,
  timeout: 20000,
  headers: {
    Accept: 'application/json'
  }
})

export default http
